module.exports = __webpack_public_path__ + "img/Feature.678c2591.jpg";